export type AppToastSeverity = 'error' | 'info' | 'success' | 'warning'

export type AppToastNotification = Readonly<{
  id: number
  message: string
  severity: AppToastSeverity
}>

let currentNotification: AppToastNotification | null = null
let nextNotificationId = 1
const listeners = new Set<() => void>()

function publish() {
  listeners.forEach((listener) => listener())
}

export function showAppToast(
  message: string,
  severity: AppToastSeverity = 'success',
) {
  currentNotification = {
    id: nextNotificationId,
    message,
    severity,
  }
  nextNotificationId += 1
  publish()
}

export function dismissAppToast(id?: number) {
  if (id !== undefined && currentNotification?.id !== id) return
  currentNotification = null
  publish()
}

export function getAppToastSnapshot() {
  return currentNotification
}

export function subscribeToAppToast(listener: () => void) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
